import $ from 'jquery';
import { resetZoom } from '~core';

export const enableOnWindowResizeListeners = () => {
  $(window).resize(function () {
    resetZoom();

    // the setTimeout is useful to detect DevTools being closed
    setTimeout(() => {
      resetZoom();
    }, 750);
  });
};
